"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var isWindowDefined = typeof window !== 'undefined';
var _default = isWindowDefined;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-optimizely/dist/utils/isWindowDefined.js
// module id = 5739
// module chunks = 11